<i18n>
{
  "fr": {
    "ClosedDate": "Date de clôture",
    "CommentCount": "Nombre de commentaires",
    "CreationDate": "Date de création",
    "ID": "ID"
  }
}
</i18n>

<template>
  <section v-if="projectPullRequests">
    <table class="table table-bordered table-striped">
      <thead class="thead-dark">
        <tr>
          <th scope="col">{{ $t('ID') }}</th>
          <th scope="col">{{ $t('CreationDate') }}</th>
          <th scope="col">{{ $t('ClosedDate') }}</th>
          <th scope="col">{{ $t('CommentCount') }}</th>
        </tr>
      </thead>
      <tbody
        v-on="$listeners">
        <tr
          v-for="pullRequest in projectPullRequests.pullRequests"
          :key="pullRequest.id">
          <td scope="row">{{ pullRequest.id }}</td>
          <td>{{ pullRequest.creationDate | formatDate }}</td>
          <td>{{ pullRequest.closedDate | formatDate }}</td>
          <td>{{ pullRequest.commentCount }}</td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('pullRequests', ['projectPullRequests']),
  },
  created() {
    this.$store.commit('pullRequests/loadedProject', this.$route.params.projectName);
  },
};
</script>
